// removed by extract-text-webpack-plugin
module.exports = {"categoriesMenu":"Categories__categoriesMenu__3aRMb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/Categories/Categories.css
// module id = 97
// module chunks = 0